import React from 'react';

import NotificationsTable from './NotificationsTable';

export default () => <NotificationsTable />;
